import React, { Component } from 'react';
import axios from "axios";
import {connect} from "react-redux";
import css from './ExistingPhotos.module.scss';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp} from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';
import { LazyLoadImage, scrollPosition } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { fetchS3Photos } from '../../utils/awsHelper';

const ExistingPhotos = class extends Component{
    // ---------- class fields: ----------
    source = axios.CancelToken.source();
    opportunityId = this.props.match.params.id;

    state = {
        photoModal: false,
        modalKey: '',
        installPhotos: [],
        electricalPhotos: [],
        batteryPhotos: [],
        inspectionPhotos: [],
        miscElectricalPhotos: [],
        mpuPhotos: [],
        serviceCallPhotos: [],
        siteSurveyPhotos: []
    };

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    getPhotosByType = async (type) => {
        let keys = {};

        await fetchS3Photos({
            recordId: this.opportunityId,
            type: '/' + type,
            process: 'getDocs',
            existingState: keys,
            source: this.source
        })
        .then(newState => {
            const stateKey = {
                install: 'installPhotos',
                electrical: 'electricalPhotos',
                battery: 'batteryPhotos',
                inspection: 'inspectionPhotos',
                miscElectrical: 'miscElectricalPhotos',
                mpu: 'mpuPhotos',
                serviceCall: 'serviceCallPhotos',
                siteSurvey: 'siteSurveyPhotos'
            }[type];

            const photos = Object.entries(newState)
                .filter(([, v]) => !Array.isArray(v))
                .map(([k, v]) => ({ Key: v, Name: k }));

            if(stateKey) {
                this.setState({ [stateKey]: photos });
            } else {
                console.warn(`Unknown photo type: ${type}`);
            }
        })
        .catch(err => {
            console.error('AWS S3 fetch error:', err);
            this.setState({ errorMessage: err.message });
        });
    }

    gallery = (images) => {
        return(
            <div className={css.ExistingPhotos__gallery}>
                {
                    images.map((image) =>
                        <div>
                            <span className="pb-2">{image.Name}</span>
                            <LazyLoadImage
                                key={image.key}
                                alt={image.Name}
                                onClick={() => this.setState({modalKey: image.Key, photoModal: true})}
                                scrollPosition={scrollPosition}
                                src={image.Key}
                                effect="blur"
                                wrapperProps={{
                                    style: {transitionDelay: "1s"},
                                }}
                            />
                        </div>
                )}
            </div>
        )
    }

    render() {
        return(
            <div>
                <h1>Existing Photos</h1>
                <div className="mt-4 text-white">
                    <div>
                        <h2 
                            className='pt-3' 
                            onClick={() =>{ 
                                this.setState({showSiteSurveyPhotos: !this.state.showSiteSurveyPhotos});
                                this.getPhotosByType('siteSurvey');
                            }}>
                                Site Survey Photos {this.state.showSiteSurveyPhotos ? <FontAwesomeIcon className='text-primary' icon={faCaretDown}/> : <FontAwesomeIcon className='text-primary' icon={faCaretUp}/>}
                        </h2>
                        <div className={this.state.showSiteSurveyPhotos ? 'text-white': 'd-none'}>
                            {this.gallery(this.state.siteSurveyPhotos)}
                        </div>
                    </div>

                    <div>
                        <h2 
                            className='pt-3' 
                            onClick={() => {
                                this.setState({showInstallPhotos: !this.state.showInstallPhotos});
                                this.getPhotosByType('install');
                            }}>
                                Install Photos {this.state.showInstallPhotos ? <FontAwesomeIcon className='text-primary' icon={faCaretDown}/> : <FontAwesomeIcon className='text-primary' icon={faCaretUp}/>}
                        </h2>
                        <div className={this.state.showInstallPhotos ? 'text-white': 'd-none'}>
                            {this.gallery(this.state.installPhotos)}
                        </div>
                    </div>

                    <div>
                        <h2 
                            className='pt-3' 
                            onClick={() =>{ 
                                this.setState({showElectricalPhotos: !this.state.showElectricalPhotos});
                                this.getPhotosByType('electrical');
                            }}>
                            Solar Electrical Photos {this.state.showElectricalPhotos ? <FontAwesomeIcon className='text-primary' icon={faCaretDown}/> : <FontAwesomeIcon className='text-primary' icon={faCaretUp}/>}
                        </h2>
                        <div className={this.state.showElectricalPhotos ? 'text-white': 'd-none'}>
                            {this.gallery(this.state.electricalPhotos)}
                        </div>
                    </div>

                    <div>
                        <h2 
                            className='pt-3'
                            onClick={() => {
                                this.setState({showBatteryPhotos: !this.state.showBatteryPhotos});
                                this.getPhotosByType('battery');
                            }}>
                                Battery Photos {this.state.showBatteryPhotos ? <FontAwesomeIcon className='text-primary' icon={faCaretDown}/> : <FontAwesomeIcon className='text-primary' icon={faCaretUp}/>}
                        </h2>
                        <div className={this.state.showBatteryPhotos ? 'text-white': 'd-none'}>
                            {this.gallery(this.state.batteryPhotos)}
                        </div>
                    </div>

                    <div>
                        <h2 
                            className='pt-3' 
                            onClick={() => {
                                this.setState({showMPUPhotos: !this.state.showMPUPhotos});
                                this.getPhotosByType('mpu');
                            }}>
                                MPU Photos {this.state.showMPUPhotos ? <FontAwesomeIcon className='text-primary' icon={faCaretDown}/> : <FontAwesomeIcon className='text-primary' icon={faCaretUp}/>}
                        </h2>
                        <div className={this.state.showMPUPhotos ? 'text-white': 'd-none'}>
                            {this.gallery(this.state.mpuPhotos)}
                        </div>
                    </div>

                    <div>
                        <h2 
                            className='pt-3' 
                            onClick={() => {
                                this.setState({showMEPhotos: !this.state.showMEPhotos});
                                this.getPhotosByType('miscElectrical');
                            }}>
                                Misc Electrical Photos {this.state.showMEPhotos ? <FontAwesomeIcon className='text-primary' icon={faCaretDown}/> : <FontAwesomeIcon className='text-primary' icon={faCaretUp}/>}
                        </h2>
                        <div className={this.state.showMEPhotos ? 'text-white': 'd-none'}>
                            {this.gallery(this.state.miscElectricalPhotos)}
                        </div>
                    </div>

                    <div>
                        <h2 
                            className='pt-3' 
                            onClick={() => {
                                this.setState({showSCPhotos: !this.state.showSCPhotos});
                                this.getPhotosByType('serviceCall');
                            }}>
                                Service Call Photos {this.state.showSCPhotos ? <FontAwesomeIcon className='text-primary' icon={faCaretDown}/> : <FontAwesomeIcon className='text-primary' icon={faCaretUp}/>}
                        </h2>
                        <div className={this.state.showSCPhotos ? 'text-white': 'd-none'}>
                            {this.gallery(this.state.serviceCallPhotos)}
                        </div>
                    </div>

                    <div>
                        <h2 
                            className='pt-3' 
                            onClick={() => {
                                this.setState({showINSPhotos: !this.state.showINSPhotos});
                                this.getPhotosByType('inspection');
                            }}>
                                Inspection Photos {this.state.showINSPhotos ? <FontAwesomeIcon className='text-primary' icon={faCaretDown}/> : <FontAwesomeIcon className='text-primary' icon={faCaretUp}/>}
                        </h2>
                        <div className={this.state.showINSPhotos ? 'text-white': 'd-none'}>
                            {this.gallery(this.state.inspectionPhotos)}
                        </div>
                    </div>

                </div>

                {/* ---------- Photo Modal: ---------- */}
                <Modal
                    isOpen={this.state.photoModal}
                    onRequestClose={() => this.setState({photoModal: false, modalKey: null})}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                          },
                          content: {
                            background: 'none',
                            border: 'none',
                            padding: '0',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            maxWidth: '100vw',
                            maxHeight: '100vh',
                            overflow: 'hidden',
                          },
                    }}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <img
                            style={{ maxWidth: '100%', maxHeight: 'auto', objectFit: 'contain' }}
                            loading="lazy"
                            src={`https://v3-portal-file-storage.s3.us-west-2.amazonaws.com/${this.state.modalKey}`}
                            onClick={() => this.setState({photoModal: false, modalKey: null})}
                            alt={this.state.modalKey}
                        />
                    </div>
                </Modal>
            </div>
        )}
};

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(ExistingPhotos);